import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=57a61afb&scoped=true&"
import script from "./Organization.vue?vue&type=script&lang=ts&"
export * from "./Organization.vue?vue&type=script&lang=ts&"
import style0 from "./Organization.vue?vue&type=style&index=0&id=57a61afb&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a61afb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCardText,VCol,VContainer,VIcon,VRow,VTooltip,VTreeview})
